import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { SInputV2 } from "../../SInputV2";
import { SSlider } from "../../SSlider";
export const CSSNumberUnitSliderEditor = ({ value, onChangeValue, unit, placeholder, label, min, step, max })=>{
    // We know now that literalValue is `css-number-unit` or `css-string`
    const getNextState = (currentState, action)=>{
        const { value } = currentState;
        const literValueIsGlobal = value?.unit == "none";
        const literalValueHasUnit = value && value?.unit !== "none";
        switch(action.type){
            case "KEY_DOWN":
                {
                    const { event } = action;
                    const key = event.key;
                    const length = value?.value;
                    const KeyMap = {
                        ArrowUp: event.shiftKey ? 10 : 1,
                        ArrowDown: event.shiftKey ? -10 : -1
                    };
                    if (key in KeyMap) {
                        const parsedLength = parseFloat(length || "");
                        const newValue = isNaN(parsedLength) ? 0 : parsedLength + KeyMap[key];
                        if (!literValueIsGlobal) {
                            return {
                                value: {
                                    type: "css-number-unit",
                                    unit: value?.unit,
                                    value: newValue.toString()
                                }
                            };
                        } else {
                            return {
                                value: {
                                    type: "css-number-unit",
                                    unit: value?.unit,
                                    value: newValue.toString()
                                }
                            };
                        }
                    }
                    break;
                }
            case "INPUT_CHANGE":
                {
                    const { value } = action;
                    const literalValue = currentState.value;
                    let length = literalValue?.value;
                    // We already have a unit, so just update the value
                    // this could also result in a weird value but that's
                    // ok for now
                    if (literalValueHasUnit) {
                        return {
                            value: {
                                type: "css-number-unit",
                                value: value,
                                unit: literalValue?.unit
                            }
                        };
                    }
                    // This may result in a weird value if you're typing 'aut' 'px'
                    // See if we can parse the value as a number
                    const parsedValue = parseFloat(value);
                    if (!isNaN(parsedValue)) {
                        return {
                            value: {
                                type: "css-number-unit",
                                value: value,
                                // Picking up the default unit
                                unit
                            }
                        };
                    }
                    // Leave this as raw to indicate
                    // that we don't know what the value is
                    return {
                        value: {
                            type: "css-number-unit",
                            value: value,
                            unit
                        }
                    };
                }
        }
        return {
            value: null
        };
    };
    const dispatch = useCallback((action)=>{
        const nextState = getNextState({
            value
        }, action);
        if (nextState.value) {
            onChangeValue && onChangeValue(nextState.value);
        }
    }, [
        getNextState,
        value
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: `bg-grayscale-dark rounded-md border border-white/10 grid  items-center ${unit ? "grid-cols-[1fr,auto,auto]" : "grid-cols-[1fr,auto]"}`,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: ` border-r border-white/10 grid ${label ? "grid-cols-[auto,1fr] gap-2 pr-3 " : "grid-cols-1 px-3"} items-center justify-center`,
                children: [
                    label && /*#__PURE__*/ _jsx("div", {
                        className: "text-xs opacity-50 px-[6px] flex items-center justify-center border-r border-white/20 h-[30px] ",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx(SSlider, {
                        min: min || 0,
                        max: max || 100,
                        step: step || 1,
                        className: "!h-[30px] !w-full",
                        value: parseFloat(value?.value === undefined ? `${placeholder && parseFloat(placeholder) || min || 0}` : value.value),
                        onChange: (value)=>{
                            dispatch({
                                type: "INPUT_CHANGE",
                                value: value.toString()
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SInputV2, {
                borderless: true,
                type: "number",
                min: min || 0,
                max: (max || 10) * 10,
                tabIndex: 1,
                className: "text-[13px] !w-[40px] !px-2 !h-[30px] !py-0 text-center",
                value: value?.value || "",
                placeholder: placeholder,
                onChange: (e)=>dispatch({
                        type: "INPUT_CHANGE",
                        value: e.target.value
                    })
            }),
            unit && /*#__PURE__*/ _jsx("p", {
                className: "text-[13px] opacity-70  pr-2",
                children: unit
            })
        ]
    });
};
